<template>
    <div class="list-product table-responsive theme-scrollbar card d-flex flex-column justify-content-between gap-3 p-3"
        style="min-height: 512px;">
        <div class=" w-100">
            <form>
                <div class=" w-100 d-flex gap-3">
                    <div class="mb-3 row justify-content-start">
                        <label for="table-complete-department"
                            class="col-xs-3 col-sm-auto col-form-label">{{ t('Department') }}:</label>
                        <div class="col-xs-3 col-sm-auto">
                            <select id="table-complete-department" class="form-select" v-model="compState.department">
                                <option value="all">{{ t('All') }}</option>
                                <option v-for="department in departmentList" :key="department.name"
                                    :value="department.name">{{
                                        department.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-3 row justify-content-start">
                        <label for="table-complete-search" class="col-xs-3 col-sm-auto col-form-label">{{ t('Search') }}:</label>
                        <div class="col-xs-3 col-sm-auto">
                            <input id="table-complete-search" type="text" class="form-control"
                                v-model="compState.searchQuery">
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-original-title="test"
                            data-bs-target="#product-add-modal">{{ t('Add Product') }}</button>
                    </div>
                </div>

                <table class="table display" id="project-status">
                    <thead>
                        <tr>
                            <th> <span class="f-light f-w-600">{{ t('Product Name') }}</span></th>
                            <th> <span class="f-light f-w-600">{{ t('Department') }}</span></th>
                            <th> <span class="f-light f-w-600">{{ t('Qty') }}</span></th>
                            <th> <span class="f-light f-w-600">{{ t('Price') }}</span></th>
                            <th> <span class="f-light f-w-600">{{ t('Barcode') }}</span></th>
                        </tr>
                    </thead>
                    <tbody v-if="!get_rows().length">
                        <tr class="odd">
                            <td valign="top" colspan="6" class="dataTables_empty">{{ t('No matching records found') }}</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr class="product-removes hover-pointer hover-shadow" v-for="(row, index) in get_rows()"
                            @click="onProductClick(row.basic.productNumber)" :key="index">
                            <td>
                                <div class="product-names">
                                    <div v-if="row.appearance.image" class="light-product-box"><img class="img-fluid"
                                            :src="row.appearance.image" alt="img">
                                    </div>
                                    <div v-else>
                                        <div class="light-product-box"></div>
                                    </div>
                                    {{ row.basic.name }}
                                </div>
                            </td>
                            <td>
                                {{ row.basic.department }}
                            </td>
                            <td>
                                {{ row.stock.currentStockLevel }}
                            </td>
                            <td>
                                {{ row.priceLevels[0]?.price || 'N/A' }}
                            </td>
                            <td>
                                {{ row.basic.barcode }}
                            </td>
                        </tr>

                    </tbody>
                </table>
            </form>
        </div>
        <div class=" w-100">
            <ul class="pagination justify-content-center pagination-primary">
                <li class="page-item"> <a class="page-link" v-on:click="prev()" aria-label="Previous"><span
                            aria-hidden="true">&laquo;</span></a></li>
                <li class="page-item" v-for="i in num_pages()" :key="i"
                    v-bind:class="[i == currentPage ? 'active' : '']" v-on:click="change_page(i)">
                    <a class="page-link">{{ i }}</a>
                </li>
                <li class="page-item"><a class="page-link" v-on:click="change()" aria-label="Next"><span
                            aria-hidden="true">&raquo;</span></a></li>
            </ul>
        </div>
    </div>
    <productAddModal @on-save="onProductSave" />
</template>

<script lang="ts" setup>
import { ref, onMounted, reactive, computed, defineAsyncComponent } from 'vue'
import { useWindowSize } from '@vueuse/core';
import { useProductsStore, defaultProduct } from '@/store/management/productsStore';
import type { Product } from '@/store/management/productsStore';
import router from '@/router';

import { useI18n } from 'vue-i18n'
import { productListTableLanguage } from '@/core/locales/products-language'

const { t } = useI18n({
  messages: productListTableLanguage
})

const productAddModal = defineAsyncComponent(() => import('@/components/managementPages/productsPage/productAddModal.vue'))

const productsStore = useProductsStore();

const compState = reactive({
    searchQuery: '',
    department: 'all',
})

const { height: screenHeight } = useWindowSize();
const elementsPerPage = computed(() => {
    if (screenHeight.value > 1200) {
        return 10;
    } else if (screenHeight.value > 800) {
        return 7;
    } else {
        return 5;
    }
});
const currentPage = ref<number>(1)

const productsList = computed(() => {
    return productsStore.getAllProducts(compState.department, compState.searchQuery);
});

const departmentList = computed(() => {
    return productsStore.getDepartmentList;
});

function get_rows() {
    var start = (currentPage.value - 1) * elementsPerPage.value;
    var end = start + elementsPerPage.value;
    return productsList.value.slice(start, end);
}
function num_pages() {
    return Math.ceil(productsList.value.length / elementsPerPage.value);
}
function change_page(page: number) {
    currentPage.value = page;
}
function change() {
    if (currentPage.value < Math.ceil(productsList.value.length / elementsPerPage.value)) {
        currentPage.value++;
    }
}
function prev() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}
onMounted(() => {
    if (productsList.value.length === 0) {
        productsStore.initializeDepartments();
        productsStore.initActiveProduct(defaultProduct);
        console.log('add new products');
    }
})

function onProductClick(id: string) {
    router.push('/management/products/details/' + id);
}

const onProductSave = (payload: Product) => {
    console.log(payload);

    productsStore.addProduct(payload);
    console.log(productsList.value);
    // router.push('/management/products/details/' + payload.basic.productNumber);
}
</script>

<style scoped lang="scss">
ul {
    user-select: none;

    li {
        cursor: pointer;
    }

}
</style>
